import useCustomisation from '@/hooks/useCustomisation'
import { useMemo } from 'react'

interface ProductSettings {
  showProductImage?: boolean
  productLayout?: 'list' | string
  showDefaultImage?: boolean
  productImageAspect?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
  productCategoryLayout?: string
}

const useProductImageState = (): {
  showImage: boolean
  listView: boolean
  showDefaultImage: boolean
  productImageAspect: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
  isTopNavLayout: boolean
} => {
  const { getLastSectionFromType } = useCustomisation()
  const { settings = {} } = getLastSectionFromType('products') as { settings: ProductSettings }

  return useMemo(() => {
    const showImage = settings.showProductImage === true
    const listView = settings.productLayout === 'list'
    const showDefaultImage =
      !listView || (listView && !!settings.showDefaultImage)
    const productImageAspect = settings.productImageAspect || 'cover'
    const isTopNavLayout = settings.productCategoryLayout === 'top'
    return {
      showImage,
      listView,
      showDefaultImage,
      productImageAspect,
      isTopNavLayout
    }
  }, [settings])
}

export default useProductImageState
